<template>
  <div class="detail-head">
    <h4 class="case-tit">
      <span class="case-no">{{commonData.caseNumber}}</span>
      <span class="case-name">{{commonData.caseName}}</span>
    </h4>
    <div class="case-step" :class="'case-step' + activeStep">
      <div class="step-item step1" :class="{'step-active': activeStep>=1}">
        <i>1</i>
        <div class="step-name">仲裁申请</div>
      </div>
      <div class="step-item step2" :class="{'step-active': activeStep>=2}">
        <i>2</i>
        <div class="step-name">组庭和辩论</div>
      </div>
      <div class="step-item step3" :class="{'step-active': activeStep>=3}">
        <i>3</i>
        <div class="step-name">案件审理</div>
      </div>
      <div class="step-item step4" :class="{'step-active': activeStep>=4}">
        <i>4</i>
        <div class="step-name">结案</div>
      </div>
    </div>
    <div class="back" @click="$emit('click')">
      <i class="el-icon-back"></i>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      stepData: {
        type: Object,
        defendant () {
          return null;
        }
      }
    },
    data() {
      return {}
    },
    computed: {
      commonData () {
        return this.stepData.caseName ? this.stepData : JSON.parse(sessionStorage.stepData);
      },
      activeStep() {
        switch (this.stepData.status || JSON.parse(sessionStorage.stepData).status) {
          case 1 :
            return 1;
          case 2 :
            return 1;
          case -1 :
            return 1;
          case 3 :
            return 2;
          case 8 :
            return 2;
          case 4 :
            return 3;
          default:
            return 4;
        }
      }
    },
    created () {
      if (this.stepData.caseName) {
        sessionStorage.stepData = JSON.stringify(this.stepData);
      } else if (!JSON.parse(sessionStorage.stepData).caseName) {
        this.$route.go(-1);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .detail-head {
    border-bottom: 10px solid #f1f0ee;
    padding-bottom: 20px;
    margin: 0 -15px 20px;
    position: relative;
    .back {
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 30px;
      cursor: pointer;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        border-top: 30px solid #d3442d;
        border-right: 40px solid #d3442d;
        border-bottom: 30px solid transparent;
        border-left: 40px solid transparent;
        z-index: 0;
      }
      i {
        position: absolute;
        font-size: 22px;
        color: #fff;
        z-index: 1;
        top: 10px;
        right: 10px;
      }
    }
  }

  .case-tit {
    padding: 40px 30px 10px;
    text-align: center;
    font-size: 26px;
  }


  .case-step {
    width: 504px;
    padding-top: 64px;
    margin: 72px auto 32px;
    display: flex;
    justify-content: space-between;
  }
  .case-step1 {
    background: url("../../assets/images/step1.jpg") no-repeat;
  }
  .case-step2 {
    background: url("../../assets/images/step2.jpg") no-repeat;
  }
  .case-step3 {
    background: url("../../assets/images/step3.jpg") no-repeat;
  }
  .case-step4 {
    background: url("../../assets/images/step4.jpg") no-repeat;
  }
  .step-item {
    position: relative;
    text-align: center;
    width: 90px;
    margin: 16px -16px 0;
    i {
      position: absolute;
      top: -61px;
      font-style: normal;
    }
  }
  .step-active {
    i {
      color: #fff;
    }
    .step-name {
      color: #d30201;
    }
  }
  .step1 {
    i {
      left: 43px;
    }
  }
  .step2 {
    i {
      left: 43px;
    }
  }
  .step3 {
    i {
      left: 40px;
    }
  }
  .step4 {
    i {
      left: 38px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/action/commonStep.vue